import { ChevronRightIcon } from 'lucide-react'

import { cn } from '@/utils'
import type { HelpSource } from '../types'

interface SourceListProps {
  sources: HelpSource[]
  activeSlug: string | null
  onSelect: (slug: string) => void
}

// The help articles behind an answer, shown as full-width tappable rows so a
// non-technical reader can plainly see there is more to read and open it. The
// row already showing in the reader is marked "Reading".
export function SourceList({ sources, activeSlug, onSelect }: SourceListProps) {
  if (sources.length === 0) return null
  return (
    <div className="mt-4 rounded-xl border border-border bg-blue-1/40 p-2">
      <p className="px-2 py-1 text-xs font-semibold uppercase tracking-wide text-blue-4">
        Related help articles
      </p>
      <div className="flex flex-col gap-0.5">
        {sources.map((source) => {
          const isActive = source.slug === activeSlug
          return (
            <button
              key={source.slug}
              type="button"
              onClick={() => onSelect(source.slug)}
              className={cn(
                'group flex w-full cursor-pointer items-center gap-3 rounded-lg border px-2.5 py-2 text-left transition-colors',
                isActive
                  ? 'border-brand/40 bg-white'
                  : 'border-transparent hover:border-border hover:bg-white',
              )}
            >
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-blue-7">
                  {source.title}
                </span>
                {source.category && (
                  <span className="block truncate text-xs text-blue-4">
                    {source.category}
                  </span>
                )}
              </span>

              {isActive ? (
                <span className="shrink-0 rounded-full bg-brand/10 px-2 py-0.5 text-xs font-semibold text-brand">
                  Reading
                </span>
              ) : (
                <ChevronRightIcon className="h-4 w-4 shrink-0 text-blue-3 transition-colors group-hover:text-brand" />
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
